module.exports = __webpack_public_path__ + "img/bg-header-small.385a796.jpg";